import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Dialog, Grid, Stack, Step, StepLabel, Stepper, Tab, Tabs, Typography } from '@mui/material';
import useAuth from 'hooks/useAuth';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import DialogClose from 'views/components/buttons/DialogClose';
import FormContainer from 'views/components/inputs/FormContainer';
import * as Yup from 'yup';
import NewFormItem from './NewFormItem';

const PreviewFormBuilder = ({
  open = true,
  showInDialog = true,
  onClose,
  title,
  titleFrench,
  description,
  descriptionFrench,
  steps,
  initialValues = {},
  preferredLanguage = 'english',
  isAdminPreview = false,
  isLoading = false,
  type,
  defaultTypeTitle,
  defaultTypeTitleFrench,
  collectScores = false,
  isForm,
  assignId,
  disableFormInputs = true,
  ...props
}: any) => {
  const intl = useIntl();
  console.log(steps, 'STEPs');
  const stepperRef = useRef<any>();
  const { userId } = useAuth();
  const [activeStep, setActiveStep] = useState(0);
  const [SelectedLanguage, setSelectedLanguage] = useState(preferredLanguage);
  console.log(userId, assignId);
  // const { updateAssignmentAsync, updateAssignmentIsLoading } = useAssignedForms({ patientId: userId, assignId });

  const [error, setError] = useState<any>(null);

  const validationSchema = useMemo(() => {
    const schemaObj = {};

    const items: any = [];
    if (type === 'stepper') {
      // if (activeStep < steps?.length - 1) {
      //   steps?.[activeStep]?.items?.forEach((item) => {
      //     if (item.mandatory) {
      //       items.push(item);
      //     }
      //   });
      // } else {
      //   steps?.forEach((step) => {
      //     step?.items?.forEach((item) => {
      //       if (item.mandatory) {
      //         items.push(item);
      //       }
      //     });
      //   });
      // }

      items?.forEach((item) => {
        console.log(item, 'ITEM');
        if (item.type === 'Questionnaire') {
          schemaObj[item.id] = Yup.object()
            .shape(
              item.items.reduce((res, item) => {
                res[item.id] = Yup.object().shape({ value: Yup.string().required(intl.formatMessage({ defaultMessage: 'Required' })) });
                return res;
              }, {})
            )
            .required(intl.formatMessage({ defaultMessage: 'Required' }));
        } else if (item.type === 'Email Field') {
          schemaObj[item.id] = Yup.string()
            .email(intl.formatMessage({ defaultMessage: 'Invalid email' }))
            .required(intl.formatMessage({ defaultMessage: 'Required' }));
        } else if ((item.type === 'Autocomplete' && item.multiple) || item.type === 'Checkbox Group') {
          schemaObj[item.id] = Yup.array()
            .of(Yup.string())
            .required(intl.formatMessage({ defaultMessage: 'Required' }));
        } else {
          schemaObj[item.id] = Yup.string().required(intl.formatMessage({ defaultMessage: 'Required' }));
        }
      });
    } else {
      // steps?.forEach((step) => {
      //   if (step.mandatory) {
      //     items.push(step);
      //   }
      // });
      items?.forEach((item) => {
        if (item.type === 'Questionnaire') {
          schemaObj[item.id] = Yup.object()
            .shape(
              item.items.reduce((res, item) => {
                res[item.id] = Yup.object().shape({ value: Yup.string().required(intl.formatMessage({ defaultMessage: 'Required' })) });
                return res;
              }, {})
            )
            .required(intl.formatMessage({ defaultMessage: 'Required' }));
        } else if (item.type === 'Email Field') {
          schemaObj[item.id] = Yup.string()
            .email(intl.formatMessage({ defaultMessage: 'Invalid email' }))
            .required(intl.formatMessage({ defaultMessage: 'Required' }));
        } else if ((item.type === 'Autocomplete' && item.multiple) || item.type === 'Checkbox Group') {
          schemaObj[item.id] = Yup.array()
            .of(Yup.string())
            .required(intl.formatMessage({ defaultMessage: 'Required' }));
        } else {
          schemaObj[item.id] = Yup.string().required(intl.formatMessage({ defaultMessage: 'Required' }));
        }
      });
    }
    return Yup.object().shape(schemaObj);
  }, [intl, type]);
  const transformDataToDefaultValues = (data, type) => {
    console.log(data, 'DATA', type);
    const defaultValues = {};
    if (type === 'default') {
      // Works for default form
      Object.entries(data).length &&
        data?.forEach((item) => {
          if (item.type === 'Questionnaire') {
            const questionnaireValues = {};
            item.items.forEach((subItem) => {
              questionnaireValues[subItem.id] = { value: subItem.value || '' };
            });
            defaultValues[item.id] = questionnaireValues;
          } else if (item.type === 'Autocomplete' && item.multiple) {
            defaultValues[item.id] = item?.value;
          } else if (item.type === 'Checkbox Group') {
            defaultValues[item.id] = item?.value;
          } else {
            defaultValues[item.id] = item?.value;
          }
        });
    } else {
      // Works for stepper form

      Object.entries(data).length &&
        data?.forEach((section) => {
          section.items.forEach((item) => {
            if (item.type === 'Questionnaire') {
              const questionnaireValues = {};
              item.items.forEach((subItem) => {
                questionnaireValues[subItem.id] = { value: subItem.value || '' };
              });
              defaultValues[item.id] = questionnaireValues;
            } else if (item.type === 'Autocomplete' && item.multiple) {
              defaultValues[item.id] = item?.value;
            } else if (item.type === 'Checkbox Group') {
              defaultValues[item.id] = item?.value;
            } else {
              defaultValues[item.id] = item?.value;
            }
          });
        });
    }
    return defaultValues;
  };
  const formContext = useForm({
    defaultValues: transformDataToDefaultValues(initialValues, type),
    resolver: yupResolver(validationSchema)
  });
  const handleStep = (step: number) => () => {
    const stepperScroll = document.getElementById('stepperScroll');
    stepperScroll?.scrollTo(125 * (step - 1), 0);
    setActiveStep(step);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    setSelectedLanguage(newValue);
    console.log(newValue, 'new value', SelectedLanguage);
  };

  const { handleSubmit } = formContext;
  const itemIdToItemMapping = useMemo(() => {
    const itemIdMap = new Map();
    const stepToItemIdMap = new Map();
    if (type === 'default') {
      steps?.forEach((step, index) => {
        itemIdMap.set(step?.id, [index, step]);
      });
      return { itemIdMap };
    }
    if (type === 'stepper') {
      steps?.forEach((step, stepIndex) => {
        console.log('STEP', step?.items);
        step?.items?.forEach((item, index) => {
          stepToItemIdMap.set(item?.id, [stepIndex, step]);
          itemIdMap.set(item?.id, [index, item?.id]);
        });
      });
    }
    return { stepToItemIdMap, itemIdMap };
  }, [steps, type]);
  const renderFormItems = useCallback(
    () => (
      <>
        {type !== 'default'
          ? steps?.[activeStep]?.items?.map((item) => (
              <Grid item xs={12} sm={item.width ? item.width : item.fullWidth ? 12 : 6} key={item.id} sx={{ marginBottom: '20px' }}>
                <NewFormItem
                  items={steps?.[activeStep]?.items}
                  item={item}
                  previewOnly
                  formContext={formContext}
                  preferredLanguage={SelectedLanguage}
                  steps={steps}
                  disableFormInputs={disableFormInputs}
                  choices={item?.choices}
                  showInput={item?.showInput}
                  inputsLabel={item?.inputsLabel}
                  inputsLabelFrench={item?.inputsLabelFrench}
                  description={item?.description}
                  collectScores={collectScores}
                  setError={setError}
                />
              </Grid>
            ))
          : steps?.map((item) => (
              <Grid item xs={12} sm={item.width ? item.width : item.fullWidth ? 12 : 6} key={item.id} sx={{ marginBottom: '20px' }}>
                <NewFormItem
                  items={steps?.items}
                  item={item}
                  previewOnly
                  disableFormInputs={disableFormInputs}
                  formContext={formContext}
                  preferredLanguage={SelectedLanguage}
                  steps={steps}
                  choices={item?.choices}
                  showInput={item?.showInput}
                  inputsLabel={item?.inputsLabel}
                  inputsLabelFrench={item?.inputsLabelFrench}
                  description={item?.description}
                  collectScores={collectScores}
                  setError={setError}
                />
              </Grid>
            ))}
      </>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [SelectedLanguage, activeStep, steps]
  );
  const Content = () => (
    <Box sx={{ width: '100%', p: 3, px: 0 }}>
      {isAdminPreview ? (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs value={SelectedLanguage} onChange={handleChange}>
            <Tab label="En" value="english" />
            <Tab label="Fr" value="french" />
          </Tabs>
        </Box>
      ) : (
        ''
      )}
      <Typography variant="h3" sx={{ my: 2 }}>
        {SelectedLanguage === 'english' ? title : titleFrench || title}
      </Typography>
      <Typography fontStyle="italic" sx={{ my: 2 }}>
        {SelectedLanguage === 'english' ? description : descriptionFrench || description}
      </Typography>

      <FormContainer formContext={formContext} onSuccess={() => {}}>
        <Box>
          <Box sx={{ width: '100%' }}>
            <Stepper
              sx={
                {
                  overflowX: 'scroll',
                  pb: 4
                } as any
              }
              ref={stepperRef}
              activeStep={activeStep}
              alternativeLabel
              nonLinear
            >
              {type === 'default' ? (
                <Step key={0}>
                  <StepLabel
                    onClick={handleStep(0)}
                    sx={{
                      // border: '1px solid grey',
                      // marginX: 2,
                      cursor: 'pointer',
                      zIndex: 3,
                      position: 'relative'
                      // backgroundColor: 'white',
                      // p: 1,
                      // pt: 2,
                      // borderRadius: 2,
                      // height: 115,
                      // width: 100
                    }}
                  >
                    {SelectedLanguage === 'english' ? defaultTypeTitle : defaultTypeTitleFrench || defaultTypeTitle}
                  </StepLabel>
                </Step>
              ) : (
                steps?.map(({ id, title, titleFrench }, index) => (
                  <Step key={index}>
                    <StepLabel
                      onClick={handleStep(index)}
                      sx={{
                        // border: '1px solid grey',
                        // marginX: 2,
                        cursor: 'pointer',
                        zIndex: 3,
                        position: 'relative'
                        // backgroundColor: 'white',
                        // p: 1,
                        // pt: 2,
                        // borderRadius: 2,
                        // height: 115,
                        // width: 100
                      }}
                    >
                      {SelectedLanguage === 'english' ? title : titleFrench || title}
                    </StepLabel>
                  </Step>
                ))
              )}
            </Stepper>
          </Box>

          <Grid container mt={2}>
            {renderFormItems()}
          </Grid>

          {!!error && (type === 'default' || activeStep === steps?.length - 1) ? (
            <Box p={3}>
              <Typography color="red" fontSize={14}>
                * <FormattedMessage defaultMessage="Please fill all the required fields" />
              </Typography>
            </Box>
          ) : null}

          <Stack direction="row" justifyContent="space-between" mt={2} mx={4}>
            <Button
              variant="contained"
              onClick={() => setActiveStep((pre) => pre - 1)}
              sx={{ visibility: type === 'default' ? 'hidden' : activeStep > 0 && steps?.length ? 'visible' : 'hidden' }}
              disabled={isLoading}
            >
              {SelectedLanguage === 'english' ? (
                <FormattedMessage defaultMessage="Previous" />
              ) : (
                <Typography fontWeight={500}>Précédent</Typography>
              )}
            </Button>
            <Button
              variant="contained"
              onClick={async () => {
                handleSubmit(
                  async (values) => {
                    if (type === 'default' || activeStep === steps?.length - 1) {
                      if (collectScores && !disableFormInputs) {
                        let res;
                        if (type === 'default') {
                          res = [...steps];

                          const i = Object.entries(values);
                          i?.forEach((item: any) => {
                            switch (itemIdToItemMapping.itemIdMap.get(item[0])[1]?.type) {
                              case 'Text Area': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalItemIndex].value = item[1];
                                break;
                              }
                              case 'Text Field': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalItemIndex].value = item[1];

                                break;
                              }
                              case 'Date Field': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalItemIndex].value = item[1];

                                break;
                              }
                              case 'Phone Number': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalItemIndex].value = item[1];

                                break;
                              }
                              case 'Email Field': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalItemIndex].value = item[1];

                                break;
                              }
                              case 'Questionnaire': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                const choiceAndValues = Object.entries(item[1]);
                                choiceAndValues?.forEach((choiceAndValue) => {
                                  const valueFromClient =
                                    choiceAndValue?.length && choiceAndValue?.length >= 2 && (choiceAndValue[1] as any)?.value;
                                  const choiceOriginalIndex = res[originalItemIndex]?.choices?.findIndex(
                                    (choice) => choice.id === valueFromClient
                                  );
                                  const itemOfItemsIndex = res[originalItemIndex].items.findIndex((z) => z.id === choiceAndValue[0]);
                                  const choiceValue = res[originalItemIndex].choices[choiceOriginalIndex]?.id;
                                  const choiceScore = res[originalItemIndex].choices[choiceOriginalIndex]?.score;
                                  res[originalItemIndex].items[itemOfItemsIndex].value = choiceValue;
                                  res[originalItemIndex].addScores && (res[originalItemIndex].items[itemOfItemsIndex].score = choiceScore);
                                });
                                break;
                              }
                              case 'Number Field': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalItemIndex].value = item[1];

                                break;
                              }
                              case 'Radio Group': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalItemIndex].value = item[1];

                                break;
                              }
                              case 'Checkbox Group': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalItemIndex].value = item[1];

                                break;
                              }
                              case 'Autocomplete': {
                                const itemId = item[0];
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalItemIndex].value = item[1];

                                break;
                              }
                              default: {
                              }
                            }
                          });
                          // await updateAssignmentAsync({ items: res });
                        }
                        if (type === 'stepper') {
                          res = [...steps];
                          const i = Object.entries(values);
                          i?.forEach((item: any) => {
                            switch (itemIdToItemMapping.itemIdMap.get(item[0])[1]?.type) {
                              case 'Text Area': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalStepIndex].items[originalItemIndex].value = item[1];
                                break;
                              }
                              case 'Text Field': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalStepIndex].items[originalItemIndex].value = item[1];
                                break;
                              }
                              case 'Date Field': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalStepIndex].items[originalItemIndex].value = item[1];
                                break;
                              }
                              case 'Phone Number': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalStepIndex].items[originalItemIndex].value = item[1];
                                break;
                              }
                              case 'Email Field': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalStepIndex].items[originalItemIndex].value = item[1];
                                break;
                              }
                              case 'Questionnaire': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                const choiceAndValues = Object.entries(item[1]);
                                choiceAndValues?.forEach((choiceAndValue) => {
                                  const valueFromClient =
                                    choiceAndValue?.length && choiceAndValue?.length >= 2 && (choiceAndValue[1] as any)?.value;
                                  const choiceOriginalIndex = res[originalStepIndex].items[originalItemIndex]?.choices?.findIndex(
                                    (choice) => choice.id === valueFromClient
                                  );
                                  const itemOfItemsIndex = res[originalStepIndex].items[originalItemIndex].items.findIndex(
                                    (z) => z.id === choiceAndValue[0]
                                  );
                                  const choiceValue = res[originalStepIndex].items[originalItemIndex].choices[choiceOriginalIndex]?.id;
                                  const choiceScore = res[originalStepIndex].items[originalItemIndex].choices[choiceOriginalIndex]?.score;
                                  res[originalStepIndex].items[originalItemIndex].items[itemOfItemsIndex].value = choiceValue;
                                  //score is not getting added to response properly plz check
                                  res[originalStepIndex].items[originalItemIndex].addScores &&
                                    (res[originalStepIndex].items[originalItemIndex].items[itemOfItemsIndex].score = choiceScore);
                                });
                                break;
                              }
                              case 'Number Field': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalStepIndex].items[originalItemIndex].value = item[1];
                                break;
                              }
                              case 'Radio Group': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalStepIndex].items[originalItemIndex].value = item[1];
                                break;
                              }
                              case 'Checkbox Group': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalStepIndex].items[originalItemIndex].value = item[1];
                                break;
                              }
                              case 'Autocomplete': {
                                const itemId = item[0];
                                const [originalStepIndex, originalStep] = itemIdToItemMapping.stepToItemIdMap?.get(itemId);
                                const [originalItemIndex, originalItem] = itemIdToItemMapping.itemIdMap.get(itemId);
                                res[originalStepIndex].items[originalItemIndex].value = item[1];
                                break;
                              }
                              default: {
                              }
                            }
                          });
                          // await updateAssignmentAsync({ steps: res });
                        }
                      }

                      onClose();
                    }
                    setActiveStep((pre) => {
                      if (pre < steps.length - 1) {
                        return pre + 1;
                      }
                      return pre;
                    });
                  },
                  (e) => {
                    // setError(e);
                    // console.error(e);
                    setActiveStep((pre) => {
                      if (pre < steps.length - 1) {
                        return pre + 1;
                      }
                      return pre;
                    });
                  }
                )();
              }}
              sx={{ visibility: steps?.length && activeStep < steps?.length ? 'visible' : 'hidden' }}
              // disabled={isLoading || updateAssignmentIsLoading}
              disabled={isLoading}
            >
              {type === 'default' || activeStep === steps?.length - 1 ? (
                SelectedLanguage === 'english' ? (
                  <Typography fontWeight={500}>Finish</Typography>
                ) : (
                  <Typography fontWeight={500}>Terminer</Typography>
                )
              ) : SelectedLanguage === 'english' ? (
                <Typography fontWeight={500}>Next</Typography>
              ) : (
                <Typography fontWeight={500}>Suivant</Typography>
              )}
            </Button>
          </Stack>
        </Box>
      </FormContainer>
    </Box>
  );

  if (!showInDialog) {
    return <Content />;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      PaperProps={{
        sx: { overflowX: 'hidden', minWidth: '70vw', minHeight: '90vh', p: 3 }
      }}
      {...props}
    >
      <DialogClose onClose={onClose} />
      <Content />
    </Dialog>
  );
};

export default PreviewFormBuilder;
